import { FormControl, MenuItem, Select, TextField } from "@material-ui/core"
import { useContext, useEffect, useState } from "react"
import useParametros from "../contexts/ParametrosContext"
import SiteContext from "../contexts/SiteContext"
import { TextosContext } from "../contexts/TextosContext"
import TelefoneMask from "../masks/telefone"
import { RegistrarLogErro } from "../services/functions"

function setMinMaxLengthDDI(ddi) {
    try {
        const ddiInput = document.getElementById("ddi-select")

        let min, max
        switch (ddi) {
            case "+55":
                min = 10
                max = 11
                break
            case "+54":
                min = 11
                max = 11
                break
            default:
                min = 10
                max = 11
                break
        }

        ddiInput.dataset.minLength = min
        ddiInput.dataset.maxLength = max
        ddiInput.dataset.codigoPais = ddiInput.textContent.replace("+", "")
    } catch (error) {
        console.error(error)
        RegistrarLogErro(error, "setMinMaxLengthDDI", ddi)
    }
}

const DDISelectInput = props => {
    return (
        <FormControl size="small" style={{ width: "5rem", marginRight: "1rem" }}>
            <Select
                id="ddi-select"
                value={props.codigoPais}
                onChange={props.handleChangeCodigoPais}
            >
                <MenuItem value="+55">+55</MenuItem>
                <MenuItem value="+54">+54</MenuItem>
            </Select>
        </FormControl>
    )
}

const TelefoneInputField = props => {
    const { usuarioLogado } = useContext(SiteContext)
    const { textos } = useContext(TextosContext)

    const [telefone, setTelefone] = useState(
        props.telefoneRef?.current ?? usuarioLogado?.cliente?.telefone?.replace(/\D/g, "")
    )

    const parametros = useParametros()

    const [codigoPais, setCodigoPais] = useState(
        usuarioLogado?.cliente?.codigoPais
            ? "+" + usuarioLogado?.cliente?.codigoPais.replace("+", "")
            : parametros.PUBLIC_DDI_PADRAO ?? "+55"
    )

    useEffect(() => {
        setMinMaxLengthDDI(codigoPais)
    }, [codigoPais])

    const handleChangeTelefone = e => {
        setTelefone(e.target.value)

        if (props.telefoneRef) props.telefoneRef.current = e.target.value.trim().replaceAll(" ", "")
    }

    const handleChangeCodigoPais = e => {
        setCodigoPais(e.target.value)

        if (props.ddiRef) props.ddiRef.current = e.target.value
    }

    return (
        <TextField
            variant="outlined"
            value={telefone}
            onChange={handleChangeTelefone}
            margin="normal"
            fullWidth
            InputProps={{
                inputComponent: TelefoneMask,
                inputProps: { codigoPais },
                startAdornment: (
                    <DDISelectInput
                        codigoPais={codigoPais}
                        handleChangeCodigoPais={handleChangeCodigoPais}
                    />
                ),
            }}
            id={props.id ?? "telefone-input"}
            name={props.name ?? "telefone-input"}
            label={textos.telefone}
        />
    )
}

export default TelefoneInputField
